<script lang="ts" setup>
	import {cn} from '@/scripts/utils/utils';
	import {
		TooltipContent,
		type TooltipContentEmits,
		type TooltipContentProps,
		TooltipPortal,
		useForwardPropsEmits,
	} from 'radix-vue';
	import {computed, type HTMLAttributes} from 'vue';

	const props = withDefaults(
		defineProps<TooltipContentProps & {class?: HTMLAttributes['class']}>(),
		{
			sideOffset: 4,
		}
	);

	const emits = defineEmits<TooltipContentEmits>();

	defineOptions({
		inheritAttrs: false,
	});

	const delegatedProps = computed(() => {
		const {class: _, ...delegated} = props;

		return delegated;
	});

	const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
	<TooltipPortal>
		<TooltipContent
			:class="
				cn(
					'bg-popover text-popover-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 overflow-hidden rounded-md border px-3 py-1.5 text-sm shadow-md',
					props.class
				)
			"
			v-bind="{...forwarded, ...$attrs}"
		>
			<slot />
		</TooltipContent>
	</TooltipPortal>
</template>
